<span
  class="munily-badge"
  [class.munily-badge--medium]="size === 'medium'"
  [class.munily-badge--large]="size === 'large'"
  [class.munily-badge--small]="size === 'small'"
  [class.munily-badge--red]="color === 'red'"
  [class.munily-badge--green]="color === 'green'"
  [class.munily-badge--yellow]="color === 'yellow'"
  [class.munily-badge--blue]="color === 'blue'"
  [class.munily-badge--neutral]="color === 'neutral'"
>
  <ng-container *ngIf="!isDot">{{ displayValue }}</ng-container>
</span>
